import React, { FunctionComponent } from 'react';
import MetaTags from 'react-meta-tags';
import Service from './services/service';
import ScrollTop from './scroll-top';
import { services } from './services/services';
import { testimonials } from '../testimonials/testimonials';
import Testimonial from '../testimonials/testimonial';
import './component.scss';

const Home: FunctionComponent = () => (
    <>
        <MetaTags>
            <title>Steadfast Electrical</title>
            <meta name="description" content="Registered and licensed Electrical Contractor offering industrial, commercial and domestic services with 22 years of experience in Paarden Eiland-Langebaan and surrounds." />
        </MetaTags>

        <div id="home">
            <div className="image-text-container">
                <h1 id="brand">
                    Professional electrical services for industrial, commercial and domestic sectors.
                </h1>
            </div>
        </div>

        <div id="about">
            <p>With over 22 years of experience in the industrial, commercial and domestic sectors, we are extremely confident in the professional advice and service we are able to offer you.</p>
            <p>We are a registered and licensed Electrical Contractor based in the Western Cape, covering all areas between Paarden Eiland and Langebaan and surrounds.</p>
        </div>

        <div id="services">
            <div className="image-text-container">
                <h2 id="services-header">Our Services</h2>
                <div id="services-container">
                    {services.reduce((rows: any[][], service, index) => {
                        if (index % 2 === 0) {
                            rows.push([service]);
                        } else {
                            rows[rows.length - 1].push(service);
                        }
                        return rows;
                    }, []).map((row, rowIndex) => (
                        <div key={rowIndex} className="services-row">
                            {row.map((s: any) => (
                                <Service
                                    key={s.name}
                                    name={s.name}
                                    description={s.description}
                                    iconClass={s.iconClass}
                                    serviceItems={s.serviceItems}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>

        <div id="testimonials">
            <div className="testimonials-content">
                <h2 id="testimonials-header">What Our Customers Say</h2>
                
                <div className="testimonials-container">
                    {testimonials.map((testimonial, index) => (
                        <Testimonial 
                            key={index}
                            name={testimonial.name}
                            company={testimonial.company}
                            comment={testimonial.comment}
                        />
                    ))}
                </div>
            </div>
        </div>

        <ScrollTop />
    </>
);

export default Home;
